import { isValidEventTypeKey, normalizeEventTypeKey } from '../eventTypes';
import { formatTimeForApi } from './buildEventFormData';
import {
  EVENT_DESCRIPTION_MAX,
  EVENT_SHORT_DESCRIPTION_MAX,
  normalizeFormMultilineField,
} from './eventFormConstants';

const isPresent = (value) => value !== null && value !== undefined && value !== '';

/** Parse API `YYYY-MM-DD` as a local calendar date (avoid UTC shift). */
export const parseExtractedEventDate = (value) => {
  if (!isPresent(value)) return null;

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    const date = new Date(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  const match = String(value)
    .trim()
    .match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    if (Number.isNaN(date.getTime())) return null;
    date.setHours(0, 0, 0, 0);
    return date;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  date.setHours(0, 0, 0, 0);
  return date;
};

/**
 * Maps POST /admin/extract-event-details `data` onto Manage Event form fields.
 * Null / empty API values are omitted so the form can still be filled by hand.
 */
export const mapExtractedEventDetailsToFormPatch = (details) => {
  if (!details || typeof details !== 'object') return {};

  const patch = {};

  if (isPresent(details.title)) {
    patch.title = String(details.title).trim();
  }

  if (isPresent(details.type)) {
    const type = normalizeEventTypeKey(details.type);
    if (isValidEventTypeKey(type)) {
      patch.type = type;
    }
  }

  if (isPresent(details.price) || details.price === 0) {
    patch.price = String(details.price);
  }

  if (isPresent(details.description)) {
    patch.description = normalizeFormMultilineField(details.description, EVENT_DESCRIPTION_MAX);
  }

  if (isPresent(details.wingmanDescription)) {
    patch.wingmanDescription = normalizeFormMultilineField(
      details.wingmanDescription,
      EVENT_SHORT_DESCRIPTION_MAX,
    );
  }

  if (isPresent(details.totalSeats)) {
    patch.totalSeats = String(details.totalSeats);
  }

  const eventDate = parseExtractedEventDate(details.eventDate);
  if (eventDate) {
    patch.eventDate = eventDate;
  }

  if (isPresent(details.startTime)) {
    patch.startTime = formatTimeForApi(details.startTime) || String(details.startTime).trim();
  }

  if (isPresent(details.endTime)) {
    patch.endTime = formatTimeForApi(details.endTime) || String(details.endTime).trim();
  }

  if (isPresent(details.venueName)) {
    patch.venueName = String(details.venueName).trim();
  }

  return patch;
};

export const countFilledDescribeFields = (patch) =>
  Object.keys(patch).filter((key) => patch[key] !== '' && patch[key] != null).length;
